import { RESET_STATE } from 'store/global/actions';

import { EXECUTIONS_ACTION_TYPE } from '../actions';

const initialState = {
  data: null,
  isLoading: false,
  hasError: false,
};

const executionsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case EXECUTIONS_ACTION_TYPE.SET_LOADING:
      return {
        ...state,
        isLoading: payload,
        hasError: payload ? false : state.hasError,
      };

    case EXECUTIONS_ACTION_TYPE.SET_ERROR:
      return { ...state, isLoading: false, hasError: true };

    case EXECUTIONS_ACTION_TYPE.GET_EXECUTIONS:
      return { ...state, data: payload ?? null, isLoading: false, hasError: false };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default executionsReducer;
